// @ts-nocheck
import React from 'react';

// Components
import { UnicoCapture } from './UnicoCapture';
import { UnicoCaptureBoundary } from './UnicoCaptureBoundary';

// Styles
import styled from 'styled-components';

const PageContainer = styled.div`
  width: 100%;
  height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
`;

interface UnicoCapurePageProps {
  formValues?: any;
  isRetention?: boolean;
}

/**
 * Página isolada para captura do SDK Unico
 * Renderiza apenas o SDK sem contexto de modal/transforms que causam congelamento
 * Similar ao /test-unico/capture mas integrada ao fluxo de /signature
 */
const UnicoCapurePageMemo = React.memo(({
  formValues,
  isRetention = false,
}: UnicoCapurePageProps) => {
  return (
    <PageContainer>
      <UnicoCaptureBoundary>
        <UnicoCapture
          formValues={formValues}
          isRetention={isRetention}
        />
      </UnicoCaptureBoundary>
    </PageContainer>
  );
},
(prev, next) => {
  return prev.isRetention === next.isRetention;
});

export const UnicoCapturePage: React.FC<UnicoCapurePageProps> = UnicoCapurePageMemo;

export default UnicoCapturePage;
